import React, { useEffect, useState } from 'react'
import { Btn, CustomModal, InputText } from '../../../../components'
import { error } from '../../../../assets/js/colors'
import { errorHandler } from '../../../../services/util/error.service'
import MultiDeliveryCycleHttp from '../../../../services/api/https/deliveries/multi-delivery-cycle.http'

const INITIAL_STATE = {
  id: undefined,
  name: '',
  operation_center_id: null,
}

export default function ModalMultiploCicloEntrega({
  visible,
  selectedMutiCiclo,
  operationCenterId,
  onResponse,
}) {
  const [mCiclo, setCiclo] = useState({ ...INITIAL_STATE })
  const [isLoading, setIsLoading] = useState(false)
  const [centerId, setCenterId] = useState(null)

  useEffect(() => {
    if (selectedMutiCiclo) {
      setCiclo({ ...selectedMutiCiclo })
    } else {
      setCiclo({ ...INITIAL_STATE })
    }
  }, [visible])

  useEffect(() => {
    if (operationCenterId) {
      setCenterId(operationCenterId)
    }
  }, [operationCenterId])

  // Event
  const onBtnSalvarClick = async () => {
    try {
      setIsLoading(true)
      // Somente Aplicável para DANONE
      const savedMultiCiclo = await MultiDeliveryCycleHttp.save({
        ...mCiclo,
        operation_center_id: centerId,
        company_id: 6,
      })
      onResponse('success', savedMultiCiclo)
    } catch (e) {
      onResponse('error', errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  // Render
  return (
    <CustomModal
      header={mCiclo.id ? 'Editando Multi-Ciclo' : 'Novo Multi-Ciclo'}
      isVisible={visible}
      onClose={() => onResponse('close')}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <small style={{ color: error }}>(*) Somente disponível para Danone</small>
        </div>
        <div className="p-col-12">
          <InputText
            label={'Descrição'}
            value={mCiclo.name}
            onChange={value => setCiclo({ ...mCiclo, name: value })}
          />
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onBtnSalvarClick}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
